import { Component, OnInit, OnDestroy } from "@angular/core";
import { CommonService } from "../../../services";
import { Observable, Subject } from "rxjs";
import { DickerSelectListItem } from "../../../models/check-out.model";
import { Router, ActivatedRoute, UrlSegment } from "@angular/router";

import { switchMap, map, takeUntil } from "rxjs/operators";
import { AuthService } from "../../../services/auth.service";
import { CheckOutService } from "../../../services/checkout.service";
import { ManageService } from "../../../services/manage.service";
import { CurrentUserModel } from "../../../models/account-ledger.model";
import { ADKDetailsViewModel } from "../../../models/adk-details-view.model";
import { ApiResponse } from "../../../models/api-response.model";
import { SubscriptionDetailsViewModel } from "../../../models/subscription-details-view.model";
import { AnnuityDetailsViewModel } from "../../../models/annuity-details-view.model";
import { PaymentDetails } from "../../../models/subscription-payment-detail.model";

@Component({
  selector: "app-spla-edit-payment",
  templateUrl: "./spla-edit-payment.component.html",
  styleUrls: ["./spla-edit-payment.component.css"],
})
export class SplaEditPayment implements OnInit, OnDestroy {

  tenantId: string;
  annuityId: string;
  programType: string;
  // purchaseAccess: string;
  // digitalWalletId: string;


  companyCode: string = "";
  setFullWindow: boolean = true;
  title: string = "Edit Tenant Details";
  loadContent: boolean = false;
  hasEmptyFilterResult: boolean = false;
  paymentList: DickerSelectListItem[] = [];
  selectedPayment: string = "";
  ngUnsubscribe: Subject<void> = new Subject<void>();
  editable = false;
  user$: Observable<CurrentUserModel>;

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private checkOutService: CheckOutService,
    private manageService: ManageService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.user$ = this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe));
    this.activatedRoute.parent.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe((segments: UrlSegment[]) => {
      this.programType = segments[0].path;
    });
    this.companyCode = this.commonService.readCookie("CompanyCode");
    $("#levelOne").animate(
      { scrollLeft: $("div.managesubscriptiondetails").width() + 505 },
      400
    );
    const subscriptionInfo$ = this.activatedRoute.parent.paramMap.pipe(
      switchMap((params: any) =>
        this.activatedRoute.parent.paramMap.pipe(
          map((param: any) => {
            return {
              // programType: this.programType,
              tenantId: param.get("tenantId"),
              annuityId: param.get("annuityId")
            };
          })
        )
      )
    );
    subscriptionInfo$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
      this.tenantId = params.tenantId;
      //this.programType = params.programType;
      this.annuityId = params.annuityId;
      this.user$.subscribe((model: CurrentUserModel) => {
          this.loadContent = false;
          this.checkOutService
            .GetSubscriptionDigitalWallet(model.loginId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (value: DickerSelectListItem[]) => {
                this.paymentList = value;
                this.loadContent = true;
                //set up editable
                this.manageService.currentPaymentDetails
                  .pipe(takeUntil(this.ngUnsubscribe))
                  .subscribe((currentDetails: PaymentDetails) => {
                    //this.purchaseAccess = currentDetails.purchaseAccess;
                    //have purchase access and doesn't have any payment method
                    if (
                      currentDetails.purchaseAccess === "Y" &&
                      !currentDetails.digitalWalletId
                    ) {
                      this.editable = true;
                      //anyone can setup a payment method
                    } else if (
                      currentDetails.purchaseAccess === "Y" &&
                      currentDetails.digitalWalletId
                    ) {
                      //only the dw owener can update payment method
                      this.checkOutService
                        .GetSubscriptionPaymentMethodList()
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe((res) => {
                          const paymentMethod = res.find(
                            (m) =>
                              m.out_customer_number ===
                              currentDetails.digitalWalletId
                          );
                          if (model.loginId == paymentMethod.out_web_login) {
                            this.selectedPayment = value.find(
                              (item) =>
                                item.value ===
                                currentDetails.digitalWalletId
                            ).value;
                            this.editable = true;
                          }
                        });
                    }
                  });
              },
              (error: any) => {
                console.info(error);
                this.loadContent = true;
              }
            );
        });
      this.loadContent = true;
    });
    // subscriptionInfo$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
    //   //console.log(params);
    //   this.tenantId = params.tenantId;
    //   this.programType = params.programType;
    //   this.annuityId = params.annuityId;
    //   if (this.programType === "KASP") {
    //     this.authService
    //       .getLoginInfo()
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe((model: CurrentUserModel) => {
    //         this.loadContent = false;
    //         this.checkOutService
    //           .GetSubscriptionDigitalWallet(model.loginId)
    //           .pipe(takeUntil(this.ngUnsubscribe))
    //           .subscribe(
    //             (value: DickerSelectListItem[]) => {
    //               this.paymentList = value;
    //               this.loadContent = true;
    //               //set up editable
    //               this.manageService.currentKaspDetailsWatch
    //                 .pipe(takeUntil(this.ngUnsubscribe))
    //                 .subscribe((currentDetails: ADKDetailsViewModel) => {
    //                   //have purchase access and doesn't have any payment method
    //                   if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     !currentDetails.customer.out_digital_wallet_id
    //                   ) {
    //                     this.editable = true;
    //                     //anyone can setup a payment method
    //                   } else if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     currentDetails.customer.out_digital_wallet_id
    //                   ) {
    //                     //only the dw owener can update payment method
    //                     this.checkOutService
    //                       .GetSubscriptionPaymentMethodList()
    //                       .pipe(takeUntil(this.ngUnsubscribe))
    //                       .subscribe((res) => {
    //                         const paymentMethod = res.find(
    //                           (m) =>
    //                             m.out_customer_number ===
    //                             currentDetails.customer.out_digital_wallet_id
    //                         );
    //                         if (model.loginId == paymentMethod.out_web_login) {
    //                           this.selectedPayment = value.find(
    //                             (item) =>
    //                               item.value ===
    //                               currentDetails.customer.out_digital_wallet_id
    //                           ).value;
    //                           this.editable = true;
    //                         }
    //                       });
    //                   }
    //                   this.details = currentDetails;
    //                 });
    //             },
    //             (error: any) => {
    //               console.info(error);
    //               this.loadContent = true;
    //             }
    //           );
    //       });
    //   } else if (this.programType === "ADY" || this.programType === "ADM") {
    //     this.authService
    //       .getLoginInfo()
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe((model: CurrentUserModel) => {
    //         this.loadContent = false;
    //         this.checkOutService
    //           .GetSubscriptionDigitalWallet(model.loginId)
    //           .pipe(takeUntil(this.ngUnsubscribe))
    //           .subscribe(
    //             (value: DickerSelectListItem[]) => {
    //               this.paymentList = value;
    //               this.loadContent = true;
    //               //set up editable
    //               this.manageService.currentADKDetailsWatch
    //                 .pipe(takeUntil(this.ngUnsubscribe))
    //                 .subscribe((currentDetails: ADKDetailsViewModel) => {
    //                   //have purchase access and doesn't have any payment method
    //                   if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     !currentDetails.customer.out_digital_wallet_id
    //                   ) {
    //                     this.editable = true;
    //                     //anyone can setup a payment method
    //                   } else if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     currentDetails.customer.out_digital_wallet_id
    //                   ) {
    //                     //only the dw owener can update payment method
    //                     this.checkOutService
    //                       .GetSubscriptionPaymentMethodList()
    //                       .pipe(takeUntil(this.ngUnsubscribe))
    //                       .subscribe((res) => {
    //                         const paymentMethod = res.find(
    //                           (m) =>
    //                             m.out_customer_number ===
    //                             currentDetails.customer.out_digital_wallet_id
    //                         );
    //                         if (model.loginId == paymentMethod.out_web_login) {
    //                           this.selectedPayment = value.find(
    //                             (item) =>
    //                               item.value ===
    //                               currentDetails.customer.out_digital_wallet_id
    //                           ).value;
    //                           this.editable = true;
    //                         }
    //                       });
    //                   }
    //                   this.details = currentDetails;
    //                 });
    //             },
    //             (error: any) => {
    //               console.info(error);
    //               this.loadContent = true;
    //             }
    //           );
    //       });
    //   } else if (this.programType === "INTA") {
    //     this.authService
    //       .getLoginInfo()
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe((model: CurrentUserModel) => {
    //         this.loadContent = false;
    //         this.checkOutService
    //           .GetSubscriptionDigitalWallet(model.loginId)
    //           .pipe(takeUntil(this.ngUnsubscribe))
    //           .subscribe(
    //             (value: DickerSelectListItem[]) => {
    //               this.paymentList = value;
    //               this.loadContent = true;
    //               //set up editable
    //               this.manageService.currentINTADetailsWatch
    //                 .pipe(takeUntil(this.ngUnsubscribe))
    //                 .subscribe(
    //                   (currentDetails: SubscriptionDetailsViewModel) => {
    //                     //have purchase access and doesn't have any payment method
    //                     if (
    //                       currentDetails.purchaseAccess === "Y" &&
    //                       !currentDetails.customer.out_digital_wallet_id
    //                     ) {
    //                       this.editable = true;
    //                       //anyone can setup a payment method
    //                     } else if (
    //                       currentDetails.purchaseAccess === "Y" &&
    //                       currentDetails.customer.out_digital_wallet_id
    //                     ) {
    //                       //only the dw owener can update payment method
    //                       this.checkOutService
    //                         .GetSubscriptionPaymentMethodList()
    //                         .pipe(takeUntil(this.ngUnsubscribe))
    //                         .subscribe((res) => {
    //                           const paymentMethod = res.find(
    //                             (m) =>
    //                               m.out_customer_number ===
    //                               currentDetails.customer.out_digital_wallet_id
    //                           );
    //                           if (
    //                             model.loginId == paymentMethod.out_web_login
    //                           ) {
    //                             this.selectedPayment = value.find(
    //                               (item) =>
    //                                 item.value ===
    //                                 currentDetails.customer
    //                                   .out_digital_wallet_id
    //                             ).value;
    //                             this.editable = true;
    //                           }
    //                         });
    //                     }
    //                     this.details = currentDetails;
    //                   }
    //                 );
    //             },
    //             (error: any) => {
    //               console.info(error);
    //               this.loadContent = true;
    //             }
    //           );
    //       });
    //   } else if (this.programType === "SPLA" || this.programType === "ISV" || this.programType === "CITRIXCSP" || this.programType === "STMSP") {
    //     this.authService
    //       .getLoginInfo()
    //       .pipe(takeUntil(this.ngUnsubscribe))
    //       .subscribe((model: CurrentUserModel) => {
    //         this.loadContent = false;
    //         this.checkOutService
    //           .GetSubscriptionDigitalWallet(model.loginId)
    //           .pipe(takeUntil(this.ngUnsubscribe))
    //           .subscribe(
    //             (value: DickerSelectListItem[]) => {
    //               this.paymentList = value;
    //               this.loadContent = true;
    //               //set up editable
    //               this.manageService.currentSPLADetailsWatch
    //                 .pipe(takeUntil(this.ngUnsubscribe))
    //                 .subscribe((currentDetails: AnnuityDetailsViewModel) => {
    //                   //have purchase access and doesn't have any payment method
    //                   if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     !currentDetails.paymentNumber
    //                   ) {
    //                     this.editable = true;
    //                     //anyone can setup a payment method
    //                   } else if (
    //                     currentDetails.puchaseAccess === "Y" &&
    //                     currentDetails.paymentNumber
    //                   ) {
    //                     //only the dw owener can update payment method
    //                     this.checkOutService
    //                       .GetSubscriptionPaymentMethodList()
    //                       .pipe(takeUntil(this.ngUnsubscribe))
    //                       .subscribe((res) => {
    //                         const paymentMethod = res.find(
    //                           (m) =>
    //                             m.out_customer_number ===
    //                             currentDetails.paymentNumber
    //                         );
    //                         if (model.loginId == paymentMethod.out_web_login) {
    //                           this.selectedPayment = value.find(
    //                             (item) =>
    //                               item.value === currentDetails.paymentNumber
    //                           ).value;
    //                           this.editable = true;
    //                         }
    //                       });
    //                   }
    //                   this.details = currentDetails;
    //                 });
    //             },
    //             (error: any) => {
    //               console.info(error);
    //               this.loadContent = true;
    //             }
    //           );
    //       });
    //   }
    // });
  }

  selectPaymentMethod() {
    if (this.annuityId && !this.tenantId) {
      this.manageService.UpdateAnnuityDigitalWallet(this.selectedPayment, this.annuityId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((value: ApiResponse) => {
          if (value.status === true) {
            this.manageService.monitorBillingInfo("Annuity");
            this.commonService.implementToast(value.responseMessage, "Success");
          } else {
            this.commonService.implementToast(value.responseMessage, "Error");
          }
        })
    } else {
      this.checkOutService
        .UpdateEBillingCustomerNo(
          this.selectedPayment,
          this.tenantId,
          this.programType
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((value: ApiResponse) => {
          if (value.status === true) {
            this.manageService.monitorBillingInfo("Subscription");
            this.commonService.implementToast(value.responseMessage, "Success");
          } else {
            this.commonService.implementToast(value.responseMessage, "Error");
          }
        })
    }
    // if (this.programType === "SPLA" || this.programType === "ISV" || this.programType === "CITRIXCSP" || this.programType === "STMSP") {
    //   this.manageService.UpdateAnnuityDigitalWallet(this.selectedPayment, this.annuityId)
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe((value: ApiResponse) => {
    //       if (value.status === true) {
    //         this.manageService.monitorBillingInfo("SPLA");
    //         this.commonService.implementToast(value.responseMessage, "Success");
    //       } else {
    //         this.commonService.implementToast(value.responseMessage, "Error");
    //       }
    //     })
    // } else {
    //   this.checkOutService
    //     .UpdateEBillingCustomerNo(
    //       this.selectedPayment,
    //       this.tenantId,
    //       this.programType
    //     )
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe((value: ApiResponse) => {
    //       if (value.status === true) {
    //         if (this.programType === "INTA") {
    //           this.manageService.monitorBillingInfo("INTA");
    //           this.commonService.implementToast(value.responseMessage, "Success");
    //         }
    //         // else if (this.programType === "SPLA" || this.programType === "ISV") {
    //         //   this.manageService.monitorBillingInfo("SPLA");
    //         //   this.commonService.implementToast(value.responseMessage, "Success");
    //         // } 
    //         else if (this.programType === "KASP") {
    //           this.manageService.monitorBillingInfo("KASP");
    //           this.commonService.implementToast(value.responseMessage, "Success");
    //         } else if (this.programType === "ADY" || this.programType === "ADM") {
    //           this.manageService.monitorBillingInfo("ADK");
    //           this.commonService.implementToast(value.responseMessage, "Success");
    //         } else if (this.programType === "CSP") {
    //           this.manageService.monitorBillingInfo("CSP");
    //           this.commonService.implementToast(value.responseMessage, "Success");
    //         }
    //       } else {
    //         this.commonService.implementToast(value.responseMessage, "Error");
    //       }
    //     });
    // }
  }

  resetPayment() {
    this.selectedPayment = "";
    this.selectPaymentMethod();
  }

  navigateToDigitalWallet() {
    this.router.navigateByUrl("/myAccount/digitalwallet?createNew=true");
  }

  close() {
    //$("#levelOne").animate({ scrollLeft: -$("#editenduser").width() }, 400);
    this.router.navigate(["../"], { relativeTo: this.activatedRoute });
    $("#levelOne").animate({ scrollLeft: 250 }, 400);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

